export class ProductNew {
  batchId: string | null = '';
  barcode: string = '';
  reference: string = '';
  description: string = '';
  productLink: string = '';
}
